export enum SectionName {
  Entities = 'entities',
  Communication = 'communication',
  Content = 'content',
  Monetization = 'monetization',
  Config = 'config'
}
